import { render, staticRenderFns } from "./deepseek.vue?vue&type=template&id=765e615c&scoped=true"
import script from "./deepseek.vue?vue&type=script&lang=js"
export * from "./deepseek.vue?vue&type=script&lang=js"
import style0 from "./deepseek.vue?vue&type=style&index=0&id=765e615c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e615c",
  null
  
)

export default component.exports